const PRODUCT_DETAILS_PAGE = 'ProductDetailsPage';

export const SentryEvents = {
    OPEN_FREQUENCY_CALCULATOR: {
        page: PRODUCT_DETAILS_PAGE,
        action: 'OPEN_FREQUENCY_CALCULATOR',
    },
    CALCULATE_AUTOSHIP_FREQUENCY: {
        page: PRODUCT_DETAILS_PAGE,
        action: 'CALCULATE_AUTOSHIP_FREQUENCY',
    },
    SET_AUTOSHIP_FREQUENCY: {
        page: PRODUCT_DETAILS_PAGE,
        action: 'SET_AUTOSHIP_FREQUENCY',
    },
    RESET_FREQUENCY_CALCULATOR: {
        page: PRODUCT_DETAILS_PAGE,
        action: 'RESET_FREQUENCY_CALCULATOR',
    },
};
